import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-grain bg-dot-pattern" data-id="element-202">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/5 rounded-full blur-[120px] pointer-events-none" data-id="element-203" />

      <div className="container mx-auto px-6 relative z-20 flex flex-col items-center text-center" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-accent/30 bg-accent/5 text-accent text-sm font-medium mb-8" data-id="element-205">
          <Sparkles size={16} className="animate-pulse" data-id="element-206" />
          <span data-id="element-207">
            Jetzt Pilotpartner werden — Sonderkonditionen für die ersten 10
            Unternehmen
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-5xl md:text-7xl lg:text-8xl font-heading leading-tight max-w-5xl mb-8" data-id="element-208">
          Wo Unternehmen KI nicht nur verstehen —{' '}
          <span className="text-accent italic" data-id="element-209">sondern umsetzen.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-xl text-muted max-w-3xl mb-12 leading-relaxed" data-id="element-210">
          Das PEZULA House of AI ist der Ort, an dem Ihre Teams gemeinsam mit
          erfahrenen AI Engineers in fokussierten Sprints echte Use Cases
          entwickeln. Keine PowerPoints. Keine Theorie. Ergebnisse.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-211">
          <a href="mailto:info@pezula.net?subject=House%20Of%20AI" className="w-full sm:w-auto px-8 py-4 bg-accent hover:bg-accent-hover text-[#020611] font-bold rounded-none transition-colors flex items-center justify-center gap-2" data-id="element-212">
            Sprint buchen
            <ArrowRight size={20} data-id="element-213" />
          </a>
          <a href="#konzept" className="w-full sm:w-auto px-8 py-4 border border-border hover:border-accent text-foreground transition-colors flex items-center justify-center" data-id="element-214">
            Konzept entdecken
          </a>
        </motion.div>
      </div>
    </section>;
}